var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-icon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"ri-menu-line ri-lg"})])
}
var staticRenderFns = []

export { render, staticRenderFns }